import React from "react";
import { View, Image } from "react-native";
import styles from "../../shared/styles";
import { global } from "../../utils";
import {Header} from "../../components/SharedComponents";
import localize from "../../shared/localize";

export default function SpreadWordContainer(props) {

    return (
        <View style={styles.container}>
            {!global.isNative && (<Header title={localize.spread_the_word} goBack={() => props.history.goBack()} />)}
            <View style={{ marginTop: 40, alignItems: "center" }}>
                <Image
                    source={{ uri: global.SPREAD_WORD_URL }}
                    style={{ width: '80%', height: 300 }}
                    resizeMode='contain'
                />
            </View>
        </View>
    )
}

SpreadWordContainer.navigationOptions = () => {
    return {
        title: localize.spread_the_word
    }
}